import React from "react"
import {
  actualiteInfos,
  actualiteImg,
  actualiteCategorie,
  actualiteTitle,
  actualiteResume,
  actualiteContainerFirst,
} from "../actualites.module.scss"
import NonStretchedImage from "../../../Image/non-stretched-image"
import SummaryTransformer from "../../../Transformers/summary-transformer"
import { summaryLength } from "../../../../constants"
import TransitionFade from "../../../transition-fade"
import { Taxo } from "./actu-item-styled"
import PropTypes from "prop-types"

const ActuItem = ({ actu, myClassName }) => {
  let image = ""
  let title = ""
  if (myClassName === actualiteContainerFirst) {
    image = (
      <NonStretchedImage
        className={actualiteImg}
        {...actu.relationships.field_image_actus?.localFile}
        ariaHidden={true}
      />
    )
    title = <div>{actu.title}</div>
  } else {
    image = (
      <TransitionFade arialabel="Lien vers l'actualité" link={actu.path.alias}>
        <NonStretchedImage
          className={actualiteImg}
          {...actu.relationships.field_image_actus?.localFile}
          ariaHidden={true}
        />
      </TransitionFade>
    )
    title = <TransitionFade link={actu.path.alias}>{actu.title}</TransitionFade>
  }
  return (
    <div className={myClassName}>
      {actu.relationships.field_image_actus?.localFile && <>{image}</>}
      <div className={actualiteInfos}>
        {actu.relationships.field_taxonomie_thematique?.length > 0 && (
          <div className={actualiteCategorie}>
            <Taxo>{actu.relationships.field_taxonomie_thematique[0].name}</Taxo>
          </div>
        )}
        <h3 className={actualiteTitle}>{title}</h3>
        {actu.body && (
          <p
            className={actualiteResume}
            dangerouslySetInnerHTML={{
              __html: SummaryTransformer(actu.body, summaryLength),
            }}
          />
        )}
      </div>
    </div>
  )
}

ActuItem.propTypes = {
  actu: PropTypes.object.isRequired,
  myClassName: PropTypes.string.isRequired,
  colors: PropTypes.object,
}

export default ActuItem
